export default __webpack_public_path__ + "static/media/photo--lg--blitz.d59fa993.jpg";